export default "__VITE_ASSET__DBmLbX$P__"